<script lang="ts" setup>
import type { ICellRendererParams } from 'ag-grid-community';
import type { PropType} from 'vue';
import { computed, onMounted, ref } from 'vue';

type ExtendedParams = ICellRendererParams & {
    title: (params: ICellRendererParams) => string;
    toggleValueTrue: (params: ICellRendererParams) => string;
    toggleValueFalse: (params: ICellRendererParams) => string;
    onClick: () => Function;
    toggleValue: () => boolean;
};

const props = defineProps({
    params: {
        type: Object as PropType<ExtendedParams>,
        required: true
    }
});

const title = computed(() => (typeof props.params.title === 'function' ? props.params.title(props.params) : props.params.title));
const toggleValueTrue = computed(() => (typeof props.params.toggleValueTrue === 'function' ? props.params.toggleValueTrue(props.params) : props.params.toggleValueTrue));
const toggleValueFalse = computed(() => (typeof props.params.toggleValueFalse === 'function' ? props.params.toggleValueFalse(props.params) : props.params.toggleValueFalse));
const onClick = computed(() => (props.params.onClick));
const toggleValue = computed(() => (props.params.toggleValue));
const toggled = ref(true);

function update():void {
    toggled.value = !toggled.value;
    onClick.value();
}

onMounted(() => {
    if (typeof toggleValue.value === 'function') {
        toggled.value = toggleValue.value();
    } else {
        console.error('toggleValue is not a function');
    }
});
</script>

<template>
    <div @click="update">
        <SText weight="medium">{{ title }} (</SText><SText :variant="toggled ? 'primary' : ''" weight="medium">{{ toggleValueTrue }}</SText> | <SText :variant="!toggled ? 'primary' : ''" weight="medium">{{ toggleValueFalse }}</SText> <SText weight="medium">)</SText>
    </div>
</template>
